"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var flex_container_1 = __importDefault(require("web/components/primitives/flex-container"));
var styles_scss_1 = __importDefault(require("./styles.scss"));
function HolidayCalendarDay(_a) {
    var holiday = _a.holiday;
    return (react_1.default.createElement(flex_container_1.default, { alignItems: "center", justifyContent: "center", className: styles_scss_1.default.holidayCalendarItem }, holiday.name));
}
exports.default = HolidayCalendarDay;
